export const CHART_COLORS = {
    primary: '#2563EB',
    secondary: '#93C5FD',
    tertiary: '#CBD5E1',
    text: '#172554',
    axis: '#CBD5E1',
    tooltipBackground: '#172554',
    tooltipText: '#FFFFFF',
    tooltipCursor: '#F8FAFC',
};

export default CHART_COLORS;
